import { z } from 'zod';

export const reportPeriodSchema = z.enum([
  'this_week',
  'this_month',
  'last_month',
  'q1',
  'q2',
  'q3',
  'q4',
  'ytd',
  'last_year',
  'custom',
]);

const ymd = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD');

export const reportsQuerySchema = z
  .object({
    period: reportPeriodSchema.default('this_month'),
    from: ymd.optional(),
    to: ymd.optional(),
  })
  .refine((q) => q.period !== 'custom' || (q.from && q.to), {
    message: 'custom period requires from and to',
  });

export type ReportsQuery = z.infer<typeof reportsQuerySchema>;
